import { sdk } from 'src/utilities/sdk';
import { decamelizeRequestBody } from 'src/utilities/http-data-casing';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

export interface UpdateEmployeeGroupsSelectionsPayload {
  groupIds: string[];
}

export async function updateEmployeeGroupsSelections(
  corpId: string,
  employeeId: string,
  payload: UpdateEmployeeGroupsSelectionsPayload
): Promise<IAsyncTaskResponse> {
  const decamelizedPayload = decamelizeRequestBody(payload);
  return sdk.http.put(
    `/corp-admin/${corpId}/diners/${employeeId}/groups`,
    decamelizedPayload
  );
}
